// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__2a_so","alertIcon":"ConfirmModal_alertIcon__3ZC3I"};